<style lang="scss">
  @use "../../../assets/css/design-system/utils";

  .counter-wrapper {
    align-self: flex-end;
    padding: 0 utils.in_rem(5px) utils.in_rem(5px);
  }
</style>

<script>
  import CharacterCounter from "../../atoms/Numbers/CharacterCounter.svelte";
  import TextInput from "./TextInput.svelte";

  export let value = "";
  export let characterLimit = 500;

  let overLimit = false;
  let state = "";

  // Update state if over the character limit
  $: state = overLimit ? "warning" : "";
</script>

<TextInput bind:value {...$$restProps} {state}>
  <div slot="right" class="counter-wrapper">
    <CharacterCounter text={value} bind:over={overLimit} {characterLimit} />
  </div>
</TextInput>
